// EditSite.js
import React, { useState, useEffect } from "react";
import { Box, TextField, Typography } from "@mui/material";
import "./Edit.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apiService from "../../utils/apiservice";




const API_URL = process.env.REACT_APP_API_DJANGO_URL;
const EditSite = ({ open, onClose, site, onSave }) => {
  const [siteData, setSiteData] = useState({
    name: "",
    latitude: "",
    longitude: "",
    survey_no: "",
    address: "",
    pin_code: "",
    society_reg_no: "",
  });

  const [errors, setErrors] = useState({});

  const coordinateRegex = /^-?\d+(\.\d{1,6})?$/;
 const fieldStyle = {
  marginBottom: "25px", // Increase space between fields
  "& .MuiOutlinedInput-root": {
    height: "auto !important", // Breaks the 40px lock from CSS
  },
  "& .MuiFormHelperText-root": {
    position: "relative !important", // CRITICAL: This pushes the next field down
    whiteSpace: "normal",
    wordBreak: "break-word",
    marginLeft: "0px",
    marginTop: "4px",
    lineHeight: "1.2",
    // Ensure the error text doesn't have a fixed height
    height: "auto !important", 
    overflow: "visible !important",
  }
};

  useEffect(() => {
    if (site) {
      setSiteData({
        name: site.name || "",
        latitude: site.latitude || "",
        longitude: site.longitude || "",
        survey_no: site.survey_no || "",
        address: site.address || "",
        pin_code: site.pin_code || "",
        society_reg_no: site.society_reg_no || "",
      });
      setErrors({});
    }
  }, [open, site]);

  const validateForm = (fieldName = null, fieldValue = null) => {
    const newErrors = { ...errors }; // copy current errors

    const fieldsToCheck = fieldName
      ? { [fieldName]: fieldValue }
      : { ...siteData };

    for (let key in fieldsToCheck) {
      const value = fieldsToCheck[key];

      if (key === "name") {
        // Must contain at least one letter, can have letters & numbers, optional single space between words
        const nameRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/;

        if (!value || !nameRegex.test(value) || value.length < 2 || value.length > 20) {
          newErrors.name =
            "Site Name must be 2-20 characters, alphanumeric, contain at least one letter, and may include one space between words.";
        } else {
          delete newErrors.name;
        }
      }

      if (key === "society_reg_no") {
        if (!value || !/^[a-zA-Z0-9/-]{2,15}$/.test(value)) {
          newErrors.society_reg_no = "Society Reg No must be 2-15 characters and can include letters, numbers, / and - only.";
        } else {
          delete newErrors.society_reg_no;
        }
      }

      if (key === "survey_no") {
        if (!value || !/^[a-zA-Z0-9\s\/-]{2,20}$/.test(value)) {
          newErrors.survey_no = "Survey No must be 2-20 characters and can include letters, numbers, spaces, / and - only.";
        } else {
          delete newErrors.survey_no;
        }
      }

      // if (key === "pin_code") {
      //   if (!/^\d{6}$/.test(value)) {
      //     newErrors.pin_code = "Pin Code must be exactly 6 digits.";
      //   } else {
      //     delete newErrors.pin_code;
      //   }
      // }


      if (key === "pin_code") {
  if (!/^[1-9][0-9]{5}$/.test(value)) {
    newErrors.pin_code =
      "Pin Code must be 6 digits and cannot start with 0.";
  } else {
    delete newErrors.pin_code;
  }
}

      // if (key === "latitude") {
      //   if (!value || isNaN(value) || value < -90 || value > 90) {
      //     newErrors.latitude = "Latitude must be between -90 and 90.";
      //   } else {
      //     delete newErrors.latitude;
      //   }
      // }

      // if (key === "longitude") {
      //   if (!value || isNaN(value) || value < -180 || value > 180) {
      //     newErrors.longitude = "Longitude must be between -180 and 180.";
      //   } else {
      //     delete newErrors.longitude;
      //   }
      // }



      if (key === "latitude") {
  if (!value) {
    newErrors.latitude = "Latitude is required";
  } else if (!coordinateRegex.test(value)) {
    newErrors.latitude = "Max 6 digits allowed after decimal";
  } else if (
    parseFloat(value) < -90 ||
    parseFloat(value) > 90
  ) {
    newErrors.latitude =
      "Latitude must be between -90 and 90";
  } else {
    delete newErrors.latitude;
  }
}

if (key === "longitude") {
  if (!value) {
    newErrors.longitude = "Longitude is required";
  } else if (!coordinateRegex.test(value)) {
    newErrors.longitude =
      "Max 6 digits allowed after decimal";
  } else if (
    parseFloat(value) < -180 ||
    parseFloat(value) > 180
  ) {
    newErrors.longitude =
      "Longitude must be between -180 and 180";
  } else {
    delete newErrors.longitude;
  }
}
      // if (key === "address") {
      //   const addressRegex = /^[a-zA-Z0-9\s,./-]{2,50}$/; // allow letters, numbers, spaces, comma, dot, /, -
      //   if (!value || !addressRegex.test(value)) {
      //     newErrors.address =
      //       "Address must be 2-50 characters and can include letters, numbers, spaces, commas, periods, / and - only.";
      //   } else {
      //     delete newErrors.address;
      //   }
      // }

     if (key === "address") {
  const value = fieldsToCheck[key];

  // Address is optional
  if (!value || value.trim() === "") {
    delete newErrors.address;
  } else {
    // Allowed characters + length
    const basicRegex = /^[a-zA-Z0-9\s,./-]{5,100}$/;

    // Prevent repeated special characters
    const invalidRepeatRegex =
      /(,){2,}|(\.){2,}|(\/){2,}|(-){2,}/;

    // Must contain at least one letter
    const hasLetter = /[a-zA-Z]/;

    if (
      !basicRegex.test(value) ||
      invalidRepeatRegex.test(value) ||
      !hasLetter.test(value)
    ) {
      newErrors.address =
        "Address must contain at least one letter. Avoid repeated symbols like // ,, .. --";
    } else {
      delete newErrors.address;
    }
  }
}
    }



    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   setSiteData((prev) => ({ ...prev, [name]: value }));

  //    validateForm(name, value);
  // };

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "name" || name === "survey_no" || name === "society_reg_no" || name === "pin_code" || name === "address") {
      // 1. Prevent leading space: If the first character is a space, clear it
      if (value.startsWith(" ")) {
        value = value.trimStart();
      }

      // 2. Prevent consecutive spaces: Replace two or more spaces with one space
      value = value.replace(/\s{2,}/g, " ");
    }

    setSiteData((prev) => ({ ...prev, [name]: value }));

    // Run validation on the processed value
    validateForm(name, value);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      const token = localStorage.getItem("accessToken");
      const assetId = site.asset_id;

      // const response = await axios.post(
      //   `${API_URL}/api/update_site/${assetId}/`,
      //   siteData,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //       Accept: "application/json",
      //       "Content-Type": "application/json",
      //     },
      //   }
      
      
      

      const response = await apiService.post(
        `/api/update_site/${assetId}/`,
        siteData
      );
      console.log("Site updated:", response.data);

      // ✅ Backend success message
      const msg =
        response.data?.message || "Site updated successfully!";

      // ✅ Show clean toast (2nd image style)
      toast.success(msg);

      // Update table
      onSave({ ...site, ...siteData });

      // Close modal
      onClose();

    } catch (error) {
      console.error("Error updating site:", error);

      // ❌ Backend error message
      const backendMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Failed to update site";

      // ❌ Show error toast
      toast.error(backendMessage);
    }
  };

  const handleCancel = () => {
    setErrors({}); // clear errors
    onClose();     // close modal
  };

  if (!open) return null;

  return (
    <div className="edit-site-modal">
      <Box component="form" className="edit-site-container edit-site-form" onSubmit={handleSubmit}>
        <Typography className="edit-site-title">Edit Site</Typography>

        <TextField
          label="Site Name"
          name="name"
          value={siteData.name}
          onChange={handleChange}
          error={!!errors.name}
          helperText={errors.name || ""}
        sx={fieldStyle}

        />
        <TextField
          label="Society Reg No"
          name="society_reg_no"
          value={siteData.society_reg_no}
          onChange={handleChange}
          error={!!errors.society_reg_no}
          helperText={errors.society_reg_no || ""}
             sx={fieldStyle}
        />
        <TextField
          label="Survey No"
          name="survey_no"
          value={siteData.survey_no}
          onChange={handleChange}
          error={!!errors.survey_no}
          helperText={errors.survey_no || ""}
             sx={fieldStyle}
        />
        <TextField
          label="Pin Code"
          name="pin_code"
          value={siteData.pin_code}
          onChange={handleChange}
          error={!!errors.pin_code}
          helperText={errors.pin_code || ""}
        />
        <TextField
          type="number"
          label="Latitude"
          name="latitude"
          value={siteData.latitude}
          onChange={handleChange}
          error={!!errors.latitude}
          helperText={errors.latitude || ""}
        />
        <TextField
          type="number"
          label="Longitude"
          name="longitude"
          value={siteData.longitude}
          onChange={handleChange}
          error={!!errors.longitude}
          helperText={errors.longitude || ""}
        />
        <TextField
          className="create-site-input"

          rows={2}
          label="Address"
          name="address"
          value={siteData.address}
          onChange={handleChange}
          error={!!errors.address} // show error if exists
          helperText={errors.address || ""} // display error text
        />

        <div className="edit-btn-wrapper">
          <button type="button" className="cancel-btn" onClick={handleCancel}>
            Cancel
          </button>
          <button type="submit" className="edit-btn">
            Save Changes
          </button>
        </div>
      </Box>
    </div>


  );
  {/* ToastContainer is always mounted */ }
  <ToastContainer position="top-right" autoClose={3000} theme="light" />
};

export default EditSite;